var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('div',{staticStyle:{"height":"90px"}},[_c('case-search',{on:{"search":_vm.search}})],1),_vm._v(" "),_c('Row',{attrs:{"gutter":16}},[_c('Col',{attrs:{"span":"20"}},[_c('case-table',{attrs:{"searchMap":_vm.searchMap}})],1),_vm._v(" "),_c('Col',{attrs:{"span":"4"}},[_c('scan-number')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e518d5d8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/components/case/caseManager/CaseManager.vue
// module id = null
// module chunks = 